// src/pages/TeacherFree/PageTeacherFreeAssistant.jsx
import React, { useState, useEffect } from "react";
import { EducaAdd } from "../../../../components/Shared/EducaAdd";
import {image} from "../../../../assets/index";
import "./PageTeacherFreeQuiz.scss";

export function PageTeacherFreeQuiz() {
  const [showAd, setShowAd] = useState(false);

  // Mostrar el modal automáticamente al montar la página
  useEffect(() => {
    setShowAd(true);
  }, []);

  const ad = {
    type: "image-text",
    src: "https://mi-cdn.com/banner.jpg",
    title: "¡Prueba Premium!",
    description: "Más funcionalidades sin anuncios.",
    ctaText: "Descubrir",
    ctaLink: "https://educa360.com/store/plan-educa-creator-anual",
  };

  return (
    <div
      className="page-teacher-free-assistant"
      style={{
        backgroundImage: `url(${image.fondoEduca})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "50vh",
        padding: "2rem",
      }}
    >
      <EducaAdd
        open={showAd}
        onClose={() => setShowAd(false)}
        adData={ad}
        size="tiny"
        confirmCloseMessage="¿Quieres cerrar este anuncio?"
      />
    </div>
  );
}
